import React, { useRef } from 'react';
import { useHistory } from 'react-router-dom';
import AliceCarousel from 'react-alice-carousel';
import images from '../../assets';
import { BlockTitle } from '../HomePage';
import { ContentsWrap, RowColum, ContentsArea, MediaQuery } from '../Common';
import Store, { get } from 'store';
import CatagoryThum from '../designthum/CatagoryThum';
import { useHomePageContext } from '../../context/HomePageContext';
import { getStringByLang } from '../../libs/lang';
import { S3_URL } from '../../libs/common';

export const CategoryView = ({ ctgresponsive, category }) => {
  const { state } = useHomePageContext();
  const ctgCarousel = useRef(null);
  const history = useHistory();

  const onCatagoryPrev = () => {
    if (ctgCarousel.current) {
      ctgCarousel.current.slidePrev();
    }
  };

  const onCatagoryNext = () => {
    if (ctgCarousel.current) {
      ctgCarousel.current.slideNext();
    }
  };

  const goCategory = (id) => {
    history.push({
      pathname: `/design/${id}/all`,
    });
  };

  const currentTitle = getStringByLang(
    state.config.main_title_4_ko,
    state.config.main_title_4_en,
    state.config.main_title_4_jp,
  );

  const categoryTitle = (item) => {
    return getStringByLang(item.ctg_name_ko, item.ctg_name_en, item.ctg_name_jp);
  };

  return (
    <>
      <ContentsWrap style={{ marginTop: '6vw' }}>
        <BlockTitle>{currentTitle}</BlockTitle>
      </ContentsWrap>
      <RowColum style={{ justifyContent: 'center', marginTop: 30 }}>
        <MediaQuery min={1366}>
          <div style={{ paddingBottom: 140, paddingRight: 25 }}>
            <div style={{ cursor: 'pointer' }} onClick={onCatagoryPrev}>
              <img alt="Previous" src={images.icon_prev} />
            </div>
          </div>
        </MediaQuery>
        <ContentsArea
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <MediaQuery max={1399}>
            <div
              style={{
                paddingBottom: 140,
                paddingRight: 25,
                height: '100%',
                position: 'relative',
                left: 60,
                zIndex: 999,
              }}
            >
              <div style={{ cursor: 'pointer', zIndex: 999 }} onClick={onCatagoryPrev}>
                <img alt="Previous" src={images.icon_prev} />
              </div>
            </div>
          </MediaQuery>
          <AliceCarousel
            ref={ctgCarousel}
            disableButtonsControls={true}
            disableDotsControls={true}
            responsive={ctgresponsive}
            controlsStrategy="alternate"
          >
            {category.map((item, index) => (
              <CatagoryThum
                key={'ctg' + index}
                bg={`${S3_URL(item.ctg_img)}`}
                title={categoryTitle(item)}
                onClick={() => goCategory(item.ctg_id)}
              />
            ))}
          </AliceCarousel>
          <MediaQuery max={1399}>
            <div
              style={{
                paddingBottom: 140,
                paddingLeft: 25,
                height: '100%',
                position: 'relative',
                right: 60,
                zIndex: 999,
              }}
            >
              <div style={{ cursor: 'pointer' }} onClick={onCatagoryNext}>
                <img alt="Next" src={images.icon_next} />
              </div>
            </div>
          </MediaQuery>
        </ContentsArea>
        <MediaQuery min={1398}>
          <div style={{ paddingBottom: 140, paddingLeft: 25 }}>
            <div style={{ cursor: 'pointer' }} onClick={onCatagoryNext}>
              <img alt="Next" src={images.icon_next} />
            </div>
          </div>
        </MediaQuery>
      </RowColum>
    </>
  );
};
export default CategoryView;
